import { NotFound } from "@dgs/core";
import { FC } from "react";
import { Route, Routes } from "react-router";
import { CategoryList } from "./CategoryList";

export const CategoryPage: FC = () => {
	return (
		<Routes>
			<Route index element={<CategoryList />} />
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
};
